import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import ReactDataGrid from 'react-data-grid';
import {Toolbar} from 'react-data-grid-addons';
import {I18n} from 'react-redux-i18n';

import ArticlesContext from './ArticlesContext';

import customer from '../../customer';
const {getActiveExcelKey, getActiveSubscriptionId, getActivePermissions} = customer.selectors;

import {ARTICLE_EXCEL_DOWNLOAD} from '../../common/apiEndpoints';

import {addArticleMapping, 
        deleteArticleMapping, 
        getArticleList, 
        sortArticles, 
        updateLabelArticle, 
        uploadExcelFile, 
        clearArticleFilters, 
        addArticleFilter,
        petLabelListReload} from '../actions';

import {areArticlesValid, getShownArticles} from '../selectors';
import {ArticleColumnsEN, ArticleColumnsDE} from './ArticleColumns';

import * as permissions from '../../common/userPermissions';

class ArticlesPage extends React.Component {
  componentWillMount() {
    const accessPermission = this.props.activePermissions.find((permission) => {
      return permission === permissions.MANAGE_ARTICLES;
    });
    if(!accessPermission)
    {
      this.props.actions.push('/labels');
    } 
     
    this.props.actions.getArticleList();
  }

  rowGetter = (i) => {
    return this.props.articleList[i];
  }

  handleFilterChange = (filter) => {
    this.props.actions.addArticleFilter(filter.column.key, filter.filterTerm);
  }

  onClearFilters = () => {
    this.props.actions.clearArticleFilters();
  }

  handleGridRowsUpdated = ({fromRow, updated}) => {
    const key = Object.keys(updated)[0];
    this.props.actions.updateLabelArticle(this.props.articleList[fromRow], key, updated[key]);
    this.props.actions.petLabelListReload(false);
  }

  handleGridSort = (sortColumn, sortDirection) => {
    this.props.actions.sortArticles(sortColumn, sortDirection);
  }

  deleteArticle = (e, {rowIdx}) => {
    this.props.actions.deleteArticleMapping(this.props.articleList[rowIdx]);
    this.props.actions.petLabelListReload(false);
  }

  copyArticle = (e, {rowIdx}) => {
    this.props.actions.addArticleMapping(this.props.articleList[rowIdx]);
    this.props.actions.petLabelListReload(false);
  }

  onUpload = (excelFile) => {
    this.props.actions.uploadExcelFile(excelFile);
    this.props.actions.petLabelListReload(false);
  }

  render() {
    const excelDownloadUrl = `${ARTICLE_EXCEL_DOWNLOAD}?subscriptionID=${this.props.subscriptionId}&key=${this.props.excelKey}`;
    
    let articleColumns = ArticleColumnsDE;
    let browserLanguage = window.navigator.language;
    browserLanguage = browserLanguage.substring(0, 2);
    if(browserLanguage === 'en')
    {
      articleColumns = ArticleColumnsEN;
    }

    return(
      <div className="container-fluid main" id="main">
        <div className="row">
          <div className="col-lg-12">
            <h1>{I18n.t('ARTICLE_MANAGEMENT')}</h1>
            <p>{I18n.t('ARTICLE_INSTRUCTIONS')}</p>
            <div className="pt-4">
              <label className="custom-file btn-upload float-right">
                <input type="file" id="file" 
                        className="custom-file-input" 
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet application/vnd.ms-excel .csv" 
                        onChange={(e) => {this.onUpload(e.target.files[0]);}}/>
                <span className="custom-file-control">{I18n.t('UPLOAD_FILE')}</span>
              </label>

              <a href={excelDownloadUrl} className="btn btn-primary float-right" download>{I18n.t('EXPORT_TO_EXCEL')}</a>

              
            </div>
          </div>
        </div>

        <div className="data-grid-wrapper">
        {this.props.articlesValid &&
          <ReactDataGrid
            contextMenu={<ArticlesContext onRowDelete={this.deleteArticle} onRowCopy={this.copyArticle}/>}
            enableCellSelect={true}
            columns={articleColumns}
            rowGetter={this.rowGetter}
            rowsCount={this.props.articleList.length}
            onGridRowsUpdated={this.handleGridRowsUpdated}
            onGridSort={this.handleGridSort}
            toolbar={<Toolbar enableAddRow={false} enableFilter={true} filterRowsButtonText={'Filter'}/>}
            onAddFilter={this.handleFilterChange}
            onClearFilters={this.onClearFilters}
          />}
        </div>
      
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    articleList: getShownArticles(state),
    articlesValid: areArticlesValid(state),
    activePermissions: getActivePermissions(state),
    excelKey: getActiveExcelKey(state),
    subscriptionId: getActiveSubscriptionId(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({addArticleMapping, 
                                  deleteArticleMapping, 
                                  getArticleList, 
                                  sortArticles, 
                                  updateLabelArticle, 
                                  uploadExcelFile, 
                                  clearArticleFilters, 
                                  addArticleFilter,
                                  petLabelListReload,
                                  push}, dispatch)
  };
}

ArticlesPage.propTypes = {
  actions: PropTypes.object.isRequired,
  activePermissions: PropTypes.array.isRequired,
  articleList: PropTypes.array.isRequired,
  articlesValid: PropTypes.bool.isRequired,
  excelKey: PropTypes.number.isRequired,
  subscriptionId: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ArticlesPage);


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/ArticlesPage.js
 **/